export const DATA_API_URL = {
  metadataQuery: '/data-retriever/metadata',
  filterQuery: '/data-retriever/filter',
  metricQuery: '/data-retriever/metric',
  dimensionedMetricQuery: '/data-retriever/dimensioned-metric',
  refreshDate: '/data-retriever/refresh-date',
  shouldRefresh: '/cache/should-refresh',
};
